import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './app.scss';

import { Container, Row, Col } from "react-bootstrap";
//import { Header } from './components/Header';
import Intro from './components/Intro';
import Footer from './components/Footer';
import ChartBox from './components/ChartBox';
import ChartBoxP from './components/ChartBoxP';
import DateRange from "./components/DateRange";
import SelectCountries from "./components/SelectCountries";
import { getDates, getValues } from './data/dataset';

const COUNTRY_1_COLOUR = '#BDEECB';
const COUNTRY_2_COLOUR = '#094151';

const lineSeries = (name, data, colour) => ({
  name: name,
  data: data,
  type: 'line',
  smooth: true,
  itemStyle: {
    borderWidth: 3,
    width: 2,
    color: colour
  }
});

function App() {
  const [scrollPosition, setScrollPosition] = useState(0);

  // null = the full range; otherwise a number of months back from the last day
  // of the data (not from today -- the dataset is a fixed Feb 2022 snapshot).
  const [months, setMonths] = useState(null)

  const [dates, setDates] = useState([])
  const [series, setSeries] = useState([])
  const [seriesP, setSeriesP] = useState([])

  const [no_embed_style, set_no_embed_style] = useState({ paddingTop: '20px' })
  const [selectedCountry1, setSelectedCountries1] = useState({
    "iso_code": "ZAF",
    "location": "South Africa"
  })
  const [selectedCountry2, setSelectedCountries2] = useState({
    "iso_code": "BWA",
    "location": "Botswana"
  })

  const country1 = selectedCountry1.location
  const country2 = selectedCountry2.location

  const countrySelect1 = (country) => setSelectedCountries1(country)
  const countrySelect2 = (country) => setSelectedCountries2(country)

  // DateRange reports 0 = last 6 months, 1 = 1 year, 2 = all
  const duration_months = (number) => {
    setMonths(number === 0 ? 6 : number === 1 ? 12 : null)
  }

  // The data is bundled, so this is a synchronous slice -- no request, no
  // loading or error state to handle.
  useEffect(() => {
    setDates(getDates(months))
    setSeries([
      lineSeries(country1, getValues(country1, 'new_tests', months), COUNTRY_1_COLOUR),
      lineSeries(country2, getValues(country2, 'new_tests', months), COUNTRY_2_COLOUR)
    ])
    setSeriesP([
      lineSeries(country1, getValues(country1, 'positive_rate', months), COUNTRY_1_COLOUR),
      lineSeries(country2, getValues(country2, 'positive_rate', months), COUNTRY_2_COLOUR)
    ])
  }, [country1, country2, months])

  const handleScroll = () => {
    setScrollPosition(window.pageYOffset);
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <div className="header pb-3">
        {/* {window.location.search != '?embed_positive' && window.location.search != '?embed_newcases' && window.location.search != '?embed' ? <Header /> : ''} */}
        {window.location.search != '?embed_positive' && window.location.search != '?embed_newcases' && window.location.search != '?embed' ?
          <Intro no_embed_style={no_embed_style}
            selectedCountry1={selectedCountry1}
            selectedCountry2={selectedCountry2}
            countrySelect1={countrySelect1}
            countrySelect2={countrySelect2}
            setDuration={duration_months}
          /> : ''}
      </div>
      <div className={scrollPosition >= 111.11112213134766 ? 'sub-top resize' : "sub-top"}>
        <Container className="justify-content-between padding-left-zero ">
          <Row>
            <Col md={6}>
              <SelectCountries
                selectedCountry1={selectedCountry1}
                selectedCountry2={selectedCountry2}
                countrySelect1={countrySelect1}
                countrySelect2={countrySelect2}
              />
            </Col>
            <Col md={6} className="d-flex justify-content-end align-items-center date_range-wrapper">
              <DateRange setDuration={duration_months} />
            </Col>
          </Row>
        </Container>

      </div>
      {window.location.search != '?embed_positive' ? <ChartBox title="New Tests: Country Comparison" series={series} dates={dates} /> : ''}
      {window.location.search != '?embed_newcases' ? <ChartBoxP title="Positivity Rate: Country Comparison" series={seriesP} dates={dates} /> : ''}
      {window.location.search != '?embed_positive' && window.location.search != '?embed_newcases' && window.location.search != '?embed' ? <Footer /> : ''}
    </>
  );
}

export default App;

const container = document.getElementsByClassName('app')[0];

ReactDOM.render(React.createElement(App), container);
